/* Follow the reading position; schedule work only when the viewport changes. */
(function () {
  'use strict';
  document.querySelectorAll('.mnl-legal').forEach(function (root) {
    if (root.dataset.spyReady) return;
    root.dataset.spyReady = '1';
    var content = root.querySelector('[data-legal-content]');
    var buttons = Array.from(root.querySelectorAll('[data-legal-language]'));
    function setLanguage(language, updateUrl) {
      language = language === 'nl' ? 'nl' : 'en';
      var template = root.querySelector('[data-legal-translation="' + language + '"]');
      if (content && template) {
        content.replaceChildren(template.content.cloneNode(true));
        content.lang = language;
      }
      buttons.forEach(function (button) {
        button.setAttribute('aria-pressed', String(button.dataset.legalLanguage === language));
      });
      document.querySelectorAll('[data-mnl-cookie-language]').forEach(function (line) {
        line.hidden = line.dataset.mnlCookieLanguage !== language;
      });
      root.querySelectorAll('a[href^="/policies/"], a[href^="/pages/cookie-policy"]').forEach(function (link) {
        var url = new URL(link.href);
        url.searchParams.set('legal_lang', language);
        link.href = url.pathname + url.search + url.hash;
      });
      if (updateUrl) {
        var url = new URL(location.href);
        url.searchParams.set('legal_lang', language);
        url.hash = '';
        history.replaceState(null, '', url);
      }
    }
    setLanguage(new URL(location.href).searchParams.get('legal_lang') || (content && content.lang), false);
    var headings = Array.from(root.querySelectorAll('.mnl-legal__body h2[id]'));
    var links = Array.from(root.querySelectorAll('.mnl-legal__sidebar ol a, .mnl-legal__mobile-toc ol a'));
    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        setLanguage(button.dataset.legalLanguage, true);
        headings = Array.from(root.querySelectorAll('.mnl-legal__body h2[id]'));
        links = Array.from(root.querySelectorAll('.mnl-legal__sidebar ol a, .mnl-legal__mobile-toc ol a'));
        current = '';
        schedule();
      });
    });
    var frame = 0, current = '';
    function update() {
      frame = 0;
      if (!headings.length) return;
      var header = document.querySelector('.mnl-header');
      var headerBottom = header ? header.getBoundingClientRect().bottom : 0;
      var line = Math.max(headerBottom + 24, Math.min(innerHeight * .25, 220));
      var selected = headings[0].id;
      for (var i = 0; i < headings.length; i++) {
        if (headings[i].getBoundingClientRect().top <= line) selected = headings[i].id;
        else break;
      }
      if (selected === current) return;
      current = selected;
      links.forEach(function (link) {
        if (link.hash === '#' + selected) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
    }
    function schedule() {
      if (!frame) frame = requestAnimationFrame(update);
    }
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('hashchange', schedule);
    window.addEventListener('pageshow', schedule);
    if (document.fonts) document.fonts.ready.then(schedule);
    schedule();
  });
}());
